var styles = {"closeButton":"OverlayCloseButton-module_closeButton__owlp3"};

export { styles as default };
